import React from 'react';
import Main from './components/Layout/main';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { FaBell } from "react-icons/fa";
import './styles/_variables.css';
import './styles/theme.css';
import './i18n'
import InactivityHandler from './components/Layout/InActivityHandler';
import i18n from './i18n';

// Import the socket setup to initialize WebSocket connection
///import './socket-setup.js'; // Adjust the path as necessary
//import { Button } from 'reactstrap';

function App() {

    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    return (
        <Router>
            <ToastContainer autoClose={5000} hideProgressBar />
            <Main />
            <InactivityHandler/>
            <div id="notification-popup" className="notification items-center gap-2 hidden">
                <div className="d-flex items-center gap-2">
                    <FaBell className="icon" size={18} style={{marginTop: '4px', color: '#d85656'}}/>
                    <div className="d-flex">
                        <p style={{marginLeft: '8px'}}>
                            
                            <span style={{color: '#d85656'}}>From : </span>
                        </p>
                        <p>
                            <span  id="notification-name">name</span>
                        </p>
                    </div>
                </div>
                <p id="notification-message" style={{marginTop: '4px',color: '#363333'}}>message</p>
                <div className="d-flex justify-content-end gap-2 mt-2">
                <button className="btn btn-default rounded btn-sm" id="close-notification">
            Close
          </button>
                    <button className="btn btn-info rounded btn-sm" id="see-notification">View</button>
                </div>
            </div>
        </Router>
    );
}

export default App;
